import { range } from 'lodash';

const MAX_RANGE = 100;

export const buildThresholds = (thresholdSteps) => {
    const normalizedStep = MAX_RANGE / thresholdSteps;
    const thresholds = range(0, MAX_RANGE + 1, normalizedStep);

    return thresholds.map((threshold) => threshold / MAX_RANGE);
};
